import _ from 'lodash';

export default {
	required(ctx, object, fieldKey, errorKey) {
		const hasError = (_.get(object, fieldKey, '') === '');
		ctx.setState({
			[errorKey]: hasError
		});
		return hasError;
	},

	emailRequired(ctx, object, fieldKey, errorKey) {
		const value = _.get(object, fieldKey, '');
		const hasError = (
			value === '' ||
			!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value)
		);
		ctx.setState({
			[errorKey]: hasError
		});
		return hasError;
	},

	colorRequired(ctx, object, fieldKey, errorKey) {
		const value = _.get(object, fieldKey, '');
		const hasError = (
			value === '' ||
			value.length !== 6 ||
			!/^[0-9A-F]{6}$/i.test(value)
		);
		ctx.setState({
			[errorKey]: hasError
		});
		return hasError;
	},

	numberRequired(ctx, object, fieldKey, errorKey) {
		try {
			const hasError = (
				!_.has(object, fieldKey) ||
				_.isNil(object[fieldKey]) ||
				object[fieldKey] === '' ||
				!_.isNumber(parseFloat(object[fieldKey]))
			);
			ctx.setState({
				[errorKey]: hasError
			});
			return hasError;
		} catch (e) {
			return true;
		}
	},

	emailExceptions(ctx, object, fieldKey, errorKey) {
		const value = _.get(object, fieldKey, '');
		const hasError = (
			value.indexOf('gmail.com') !== -1 ||
			value.indexOf('hotmail.com') !== -1 ||
			value.indexOf('outlook.com') !== -1 ||
			value.indexOf('yahoo.com') !== -1 ||
			value.indexOf('mail.com') !== -1 ||
			value.indexOf('inbox.com') !== -1 ||
			value.indexOf('aol.com') !== -1
		);
		ctx.setState({
			[errorKey]: hasError
		});
		return hasError;
	},

	password(ctx, object, fieldKey, reFieldKey, errorKey) {
		try {
			const password = _.get(object, fieldKey, '');
			const passwordRe = _.get(object, reFieldKey, '');

			const hasError = (password !== passwordRe);

			ctx.setState({
				[errorKey]: hasError
			});
			return hasError;
		} catch (e) {
			return true;
		}
	}
};



// WEBPACK FOOTER //
// ./src/helpers/validator.js